export type ApiResponse<T> = {
  data: T
  message?: string
  code?: number
  status?: string
  state?: string
  success?: boolean
}

export type PaginatedResponse<T> = ApiResponse<T> & {
  pagination: {
    total: number
    page: number
    limit: number
    pages: number
  }
}

export type ErrorResponse = {
  message: string
  code?: number
  data?: unknown
}

export enum EApiVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
  V4_NEW = 'v4new',
}

// API luc thi text luc thi number ???
export enum EApiStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

// TODO: Sửa lại type này
export type PaginatedReviewResponse<T> = {
  data: T
  current_page: number
  last_page: number
  per_page: number
  total: number
  from?: number
  to?: number
  links?: {
    url: string | null
    label: string
    active: boolean
  }[]
}
